export default __webpack_public_path__ + "static/media/avatar_132.91c390e8.png";